module.exports = __webpack_public_path__ + "static/html-element_1-be40040893683dad3b158887a8baa7a8.jpg";